import ImageBasic from "../Common/Image/ImageBasic";

const StatCard = ({icon, count, label, onHandleClick}) => (
    <div
        className={`md:flex items-center justify-center md:space-x-5 bg-green-50 py-[10px] px-[6px] rounded-lg cursor-pointer`}
        onClick={onHandleClick}>
        <div
            className="text-2xl mb-2 md:mb-0 flex justify-center items-center md:w-16 md:h-16 md:rounded-full md:bg-white">
            <ImageBasic className='w-5 md:w-6' src={icon}/>
        </div>
        <div>
            <div className="text-[9px] md:text-sm text-gray-600 md:text-black">{label}</div>
            <div className={`text-xl md:text-3xl font-bold`}>{count}</div>
        </div>
    </div>
);
export default StatCard;